<template>
    <el-drawer
        :before-close="cancel"
        :title="`党建经费`"
        :visible.sync="dialogVisible"
        width="600px">
        <div class="flex flex-direction padding-lr">
            <div class="text-sm text-bold text-black">日期</div>
            <div class="text-sm text-black margin-top-xs">{{ detail.funding_time }}</div>
            <el-divider></el-divider>
            <div class="text-sm text-bold text-black">类型</div>
            <div class="text-sm text-black margin-top-xs">{{ detail.type ? '收入'  : '支出'}}</div>
            <el-divider></el-divider>
            <div class="text-sm text-bold text-black">经费名称</div>
            <div class="text-sm text-black margin-top-xs">{{ detail.name }}</div>
            <el-divider></el-divider>
            <div class="text-sm text-bold text-black">发生金额</div>
            <div class="text-sm text-black margin-top-xs">{{ detail.amount}}元</div>
            <el-divider></el-divider>
            <div class="text-sm text-bold text-black">{{detail.type === 1 ? '备注' : '经费说明'}}</div>
            <div class="text-sm text-black margin-top-xs">{{ detail.type === 1 ? detail.remark : detail.content }}</div>
            <el-divider></el-divider>
            <div class="text-sm text-bold text-black">附件</div>
            <div class="flex flex-direction align-start">
                <el-link class="text-red text-xs margin-top-xs" target="_blank" :href="item.url" v-for="(item,index) in detail.file_url" :key="index">{{item.name}}</el-link>
            </div>
        </div>
    </el-drawer>
</template>

<script>

import {zhDate} from "@/utils/utils";
import {fundingDetail} from "@/api";
import {BASE_URL} from "@/config";

export default {
    name: "ExpenditureDetailDialog",
    components: {},
    data() {
        return {
            detail: '',
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        eid: {
            type: Number,
            default: 0
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    created() {
        if (this.eid) this.init()
    },
    methods: {
        async init() {
            let _data = await fundingDetail(this.eid)
            _data.data.funding_time = zhDate(_data.data.funding_time)
            _data.data.file_url =  _data.data.file_url ? JSON.parse(_data.data.file_url) : []
            _data.data.file_url.map(item=>{
                item.url = BASE_URL + item.url
            })
            this.detail = _data.data
        },
        cancel() {
            this.$emit('watchState', false)
        },
    },
    filters: {},
    watch: {
        eid() {
            if (this.eid) this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
.images {
    .image {
        width: 100px;
        height: 100px;
        &:not(:nth-child(3n+1)) {
            margin-left: 10px;
        }
    }

}

</style>